// NOTE: This is a restriction from algolia.
// Only use alphanumeric, equal, plus, slash, hyphen, or underscore characters as prefix.
const uniqueIdGenerator = (prefix = '') => {
  try {
    return prefix + crypto.randomUUID()
  } catch {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return prefix + `_${Math.random().toString(36).substr(2, 9)}`
  }
}
export default uniqueIdGenerator
